import FormatCurrency from 'components/Common/FormatCurrency'
import CheckboxInput from 'components/Luxkit/Checkbox/CheckboxInput'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import useTailorMadeTour from 'hooks/TourV2/useTailorMadeTour'
import React from 'react'

function TailorMadeTourAcknowledgementInput() {
  const tailorMadeTour = useTailorMadeTour()

  return <CheckboxInput required name="acknowledgement">
    I understand that a{' '}
    {!tailorMadeTour.data && <TextLoadingBox width="4ch" />}
    {tailorMadeTour.data && <FormatCurrency value={tailorMadeTour.data?.fee} />}
    {' '}deposit is required to begin creating my custom tour. If I decide not to proceed, the deposit will be fully refunded.
  </CheckboxInput>
}

export default TailorMadeTourAcknowledgementInput
